import React from 'react';
import AHMLogo from '../../assets/logo/AHM.png';
import HBAOGLogo from '../../assets/logo/HBAOG.png';
import NAHBLogo from '../../assets/logo/NAHB.png';
import NASCLALogo from '../../assets/logo/NASCLA.png';

const AssociationsSection: React.FC = () => {
  const associations = [
    {
      name: 'Greater Atlanta Home Builders Association',
      logo: AHMLogo
    },
    {
      name: 'Home Builders Association of Georgia',
      logo: HBAOGLogo
    },
    {
      name: 'National Association of Home Builders',
      logo: NAHBLogo
    },
    {
      name: 'National Association of State Contractors Licensing Agencies',
      logo: NASCLALogo
    }
  ];

  return (
    <section className="section bg-white">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="mb-4">Professional Associations</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We are proud members of leading industry associations, ensuring we maintain the highest standards of quality and professionalism in home building.
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 items-center justify-items-center">
          {associations.map((association, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center justify-center p-2 hover:scale-105 transition-transform duration-300"
            >
              <div className="bg-white rounded-lg shadow-sm p-8 w-full h-40 flex items-center justify-center">
                <img
                  src={association.logo}
                  alt={association.name}
                  className="max-w-full max-h-full object-contain filter hover:brightness-110 transition-all duration-300"
                />
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-sm text-gray-600">
            Our memberships reflect our commitment to industry best practices, continuous education, and professional excellence.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AssociationsSection; 